import React, { useState } from 'react';
import { useComboTooltipHint } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/logic/useComboTooltipHint';
import {
  FormCombination,
  FormWordGroup,
} from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/models/ComboFormState';
import VoxelChip from '../../voxel/Chips/VoxelChip';

export interface ComboChipProps {
  cc: FormCombination;
  wordGroups: FormWordGroup[];
  handleDeselectWordCombination: (cc: FormCombination) => void;
  disabled: boolean;
}

export const ComboChip: React.FC<ComboChipProps> = React.memo(
  ({ cc, wordGroups, handleDeselectWordCombination, disabled }) => {
    // We have a local hiding of the component - to handle debounce delay
    const [show, setShow] = useState(true);
    if (!show) {
      return null;
    }

    return (
      <VoxelChip
        tooltip={useComboTooltipHint(cc, wordGroups).title}
        title={cc.name}
        disabled={disabled}
        close
        onClick={() => {
          setShow(false);
          handleDeselectWordCombination(cc);
        }}
        color={
          cc.wordGroups.some((CCwg) => wordGroups.find((wg) => wg.id === CCwg.id).words === '')
            ? 'error'
            : 'success'
        }
      />
    );
  }
);
